import React from "react";
import styled from "styled-components";
import { mobile, mobileM, tablet, laptop, laptopM } from "../../responsive";
//
//https://www.npmjs.com/package/react-player
// import ReactPlayer from "react-player";
// import videoCity1 from "../../videos/smartphone-cottonbro_lwres.mp4";
import ScrollToTop from "../ScrollToTop";
//
import imgSmile from "../../lib/pexels_cottonbro_lwres_retouched.jpg";
import imgSvg from "../../lib/wild-underline-2.svg";
//

const SectionTop = styled.div`
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  position: relative;
  //
  //
  background-color: #fff;

  //
  &:after {
    content: "";
    z-index: 1;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    pointer-events: none;
    //

    background: linear-gradient(0deg, rgba(171, 171, 245, 0), rgba(0, 0, 0, 0)),
      url(https://grainy-gradients.vercel.app/noise.svg);
    filter: contrast(1500%) brightness(180%);
  }

  // *** Media queries
  //
  ${mobile({
    height: "70vh",
    borderBottom: "9px solid #121212",
    borderRadius: "0px 0px 146px 146px",
    margin: "0 0  25px 0",
  })}
  ${mobileM({
    height: "70vh",
    borderBottom: "9px solid #121212",
    borderRadius: "0px 0px 146px 146px",
    margin: "0 0  25px 0",
  })}
  ${tablet({
    height: "70vh",
    borderBottom: "9px solid #121212",
    borderRadius: "0px 0px 146px 146px",
  })}
  ${laptop({
    height: "100vh",
    minHeight: "70vh",
    borderBottom: "9px solid #121212",
    borderRadius: "0px 0px 146px 146px",
  })}
  ${laptopM({
    height: "80vh",
    minHeight: "70vh",
    borderBottom: "9px solid #121212",
    borderRadius: "0px 0px 146px 146px",
    margin: "0 0  0 0",
  })}
`;
const BannerBottomContainer = styled.div`
  width: 100%;
  height: 100%;
  overflow: hidden;
  /*  */
  position: relative;
  background-image: url(${imgSmile});
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  background-attachment: local;
  //

  //
  //
  ${mobile({
    width: "100%",
    height: "100%",
  })}
  ${mobileM({})} 
  ${tablet({})}
`;

const VideoProductContainer = styled.div`
  /* z-index: -97; when i hid this one the icon scroll to bottom worked */
  //
  width: 100%;
  height: 100%;

  position: relative;
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  opacity: 0.9;

  //
  ${mobileM({
    position: "relative",
    width: "100%",
    height: "100%",
    margin: "0",
    textAlign: "center",
    maxWidth: "1000px",
  })}

  //
  // ------ video product box -----
  //
  //
  .video__product__box {
    width: 100%;
    height: 100%;
    object-fit: cover;

    ${mobileM({
      minHeight: "auto",
    })}
  }
  /* 
  
  
          Container Text
  
  
  
  */
  .video__product__overlay {
    width: 100%;
    height: 100%;
    //
    overflow-y: hidden;
    pointer-events: none;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    z-index: 98;

    &:after {
      content: "";
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      pointer-events: none;
      //
      background-image: url(${imgSvg});
      background-repeat: no-repeat;
      background-position: center;
      background-size: 65%;
      background-attachment: fixed;
    }

    //
    //
    // *** MEDIA queries
    ${mobile({
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      flexDirection: "column",

      "&:after": {
        content: "''",
        backgroundPosition: "center 20%",
        backgroundSize: "105%",
        backgroundAttachment: "fixed",
      },
    })}

    //
    ${mobileM({
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      flexDirection: "column",
      "&:after": {
        content: "''",
        backgroundPosition: "center 10%",
        backgroundSize: "105%",
        backgroundAttachment: "fixed",
      },
    })}
        ${tablet({
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      flexDirection: "column",
      "&:after": {
        content: "''",
        backgroundPosition: "center -10%",
        backgroundSize: "95%",
        backgroundAttachment: "fixed",
      },
    })}
  }
`;
//
// --------------
// ***  Look, Touch Sense
//
const TitleLarge = styled.h2`
  text-align: center;
  font-family: "Poppins-Light";
  color: rgb(248, 248, 248);
  font-size: 5.5em;
  font-weight: 600;
  word-wrap: break-word;
  //
  //
  ${mobile({
    // color: "pink",
    fontSize: `calc(20px + 1.1vmin)`,
    lineHeight: `calc(21px + 1.1vmin)`,
  })}
  ${mobileM({
    // color: "red",
    fontSize: `calc(35px + 1.1vmin)`,
    lineHeight: `calc(36px + 1.1vmin)`,
  })};
  ${tablet({
    // color: "green",
    fontSize: `calc(65px + 1.1vmin)`,
    lineHeight: `calc(78px + 1.1vmin)`,
  })} //
    ${laptop({
    // color: "fuchsia",
    fontSize: `calc(80px + 1.1vmin)`,
    lineHeight: `calc(78px + 1.1vmin)`,
  })} //
`;
//
//
// --------------
// ***  The flowing excitement
//
const TitleSmall = styled.p`
  margin-top: 5px;
  color: rgb(248, 248, 248);
  /*  */
  font-size: 2em;
  font-family: "PoppinsThin";
  font-weight: 600;
  letter-spacing: 1px;
  word-wrap: break-word;

  text-align: center;
  //
  //
  ${mobile({
    width: "80%",
    fontSize: `calc(12px + 1.1vmin)`,
    lineHeight: `calc(13px + 1.1vmin)`,
  })}
  ${mobileM({
    width: "80%",
    fontSize: `calc(12px + 1.1vmin)`,
    lineHeight: `calc(13px + 1.1vmin)`,
  })};
`;

//
//
//        BOUNCING BUTTON
//

/*
 */
const BannerBottom = () => {
  return (
    <>
      <section>
        <SectionTop>
          <BannerBottomContainer>
            <VideoProductContainer>
              <div className="video__product__overlay">
                <TitleLarge> Look, Touch, Sense.</TitleLarge>
                <TitleSmall> The Flowing Excitement in Your Hand.</TitleSmall>
                <ScrollToTop />
              </div>
            </VideoProductContainer>
          </BannerBottomContainer>
        </SectionTop>
      </section>
    </>
  );
};
export default BannerBottom;

/*


 <div id="video__product__container">
            <video autoPlay muted loop className="video__product__box">
              <source src={videoCity1} type="video/mp4" />
            </video>
            <div className="video__product__overlay">
              <h2> Look, Touch, Sense.</h2>
              <p> The Flowing Excitement in Your Hand.</p>
            </div>
          </div>


*/
